




































































import { Component, Prop, Vue } from "@/shared/vuepack";
import { useEmploymentStore } from "@/employer/store/employment";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { formatMMddyyyyDateString } from "@/shared/dateString";
import { FetchState, EmploymentStatus } from "@/shared/types";
import AccountHolderWidgetBase from "@/employer/components/partner-ee-service/AccountHolderWidgetBase.vue";

interface CombinedEmploymentData {
  employerName: string;
  customEmployerId: string;
  employerSpecifiedId: string;
  employeeIdRef: string;
  dateOfHire: string;
  employmentStatus: EmploymentStatus;
  statusEffectiveDate: string;
  terminationDate: string;
  payrollFrequency: string;
  payrollFrequencyEffectiveDate: string;
  employeeClassification: string;
  employeeClassificationEffectiveDate: string;
  employerDivision: string;
  wexEmployerCode: string;
}

@Component({
  components: {
    AccountHolderWidgetBase
  }
})
export default class AccountHolderEmployer extends Vue {
  employmentStore = useEmploymentStore();
  contactInfoStore = useContactInfoStore();

  @Prop({ required: true })
  username: string;

  @Prop({ required: true })
  partnerId: number;

  loadData () {
    const args = { username: this.username, partnerId: this.partnerId };
    this.employmentStore.loadEmploymentInfo(args);
    this.contactInfoStore.getContactInformation(args);
  }

  get employmentInfo (): CombinedEmploymentData {
    if (!this.isLoaded) {
      return null;
    }

    if (!this.contactInfoStore.contactInformation.employmentInfo || !this.employmentStore.employmentInfo) {
      return null;
    }

    const employmentInfo: CombinedEmploymentData = {
      employerName: this.employmentStore.employmentInfo.employerName,
      customEmployerId: this.employmentStore.employmentInfo.customEmployerId,
      employerSpecifiedId: this.employmentStore.employmentInfo.employerSpecifiedId,
      employeeIdRef: this.employmentStore.employmentInfo.employeeIdRef,
      dateOfHire: this.contactInfoStore.contactInformation.employmentInfo.dateOfHire,
      employmentStatus: this.employmentStore.employmentInfo.employmentStatus,
      statusEffectiveDate: this.employmentStore.employmentInfo.statusEffectiveDate,
      terminationDate: this.employmentStore.employmentInfo.terminationDate,
      payrollFrequency: this.contactInfoStore.contactInformation.employmentInfo.payrollFrequency,
      payrollFrequencyEffectiveDate: this.contactInfoStore.contactInformation.employmentInfo.payrollFrequencyEffectiveDate,
      employeeClassification: this.contactInfoStore.contactInformation.employmentInfo.employeeClassification,
      employeeClassificationEffectiveDate: this.contactInfoStore.contactInformation.employmentInfo.employeeClassificationEffectiveDate,
      employerDivision: this.contactInfoStore.contactInformation.employmentInfo.employerDivision,
      wexEmployerCode: this.employmentStore.employmentInfo.wexEmployerCode
    };

    return employmentInfo;
  }

  get isLoading () {
    return this.employmentStore.isLoading || this.contactInfoStore.contactInformationState === FetchState.Loading;
  }

  get isLoaded () {
    return this.employmentStore.isLoaded && this.contactInfoStore.contactInformationState === FetchState.Loaded;
  }

  get isFailed () {
    return this.employmentStore.isFailed || this.contactInfoStore.contactInformationState === FetchState.Failed;
  }

  formatDate (date: string) {
    return formatMMddyyyyDateString(date);
  }
}
